import { __module as d } from "./ghl-ui.es1691.js";
(function(m, r) {
  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.default = void 0;
  var i = function(t, e) {
    switch (t) {
      case "P":
        return e.date({
          width: "short"
        });
      case "PP":
        return e.date({
          width: "medium"
        });
      case "PPP":
        return e.date({
          width: "long"
        });
      case "PPPP":
      default:
        return e.date({
          width: "full"
        });
    }
  }, u = function(t, e) {
    switch (t) {
      case "p":
        return e.time({
          width: "short"
        });
      case "pp":
        return e.time({
          width: "medium"
        });
      case "ppp":
        return e.time({
          width: "long"
        });
      case "pppp":
      default:
        return e.time({
          width: "full"
        });
    }
  }, h = function(t, e) {
    var s = t.match(/(P+)(p+)?/) || [], P = s[1], c = s[2];
    if (!c)
      return i(t, e);
    var a;
    switch (P) {
      case "P":
        a = e.dateTime({
          width: "short"
        });
        break;
      case "PP":
        a = e.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        a = e.dateTime({
          width: "long"
        });
        break;
      case "PPPP":
      default:
        a = e.dateTime({
          width: "full"
        });
        break;
    }
    return a.replace("{{date}}", i(P, e)).replace("{{time}}", u(c, e));
  }, n = {
    p: u,
    P: h
  }, p = n;
  r.default = p, m.exports = r.default;
})(d, d.exports);
var o = d.exports;
export {
  o as l
};
